import { AxiosResponse } from 'axios';

import IListResponse from '^types/IListResponse';
import ICarColor from '^types/ICarColor';

import { apiClient } from '.';

export const requestCarVariantColors = (code: string): Promise<AxiosResponse<IListResponse<ICarColor>>> =>
  apiClient.get(`/Variants/${code}/Colors`);
